<script setup lang="ts">
import AppRawButton from '../appRawButton/AppRawButton.vue';

interface AppNavItemProps {
  text: string;
}

const props = defineProps<AppNavItemProps>();

interface AppNavItemEmits {
  (event: 'click'): void;
}

const emit = defineEmits<AppNavItemEmits>();
</script>

<template>
  <AppRawButton class="app-nav-item" @click="emit('click')">
    {{ props.text }}
  </AppRawButton>
</template>

<style scoped lang="scss">
@import '../../styles/_fonts.scss';
.app-nav-item {
  color: var(--color-neutral-70);
  @include font-label-m-bold;
  cursor: pointer;
  padding: 0;
  margin: 0;
}
</style>
